import { render, staticRenderFns } from "./LpProductPicker.vue?vue&type=template&id=32da6c1f&"
import script from "./LpProductPicker.vue?vue&type=script&lang=js&"
export * from "./LpProductPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports